import React from 'react';
import moment from 'moment';
import HForm, {
  TextField,
  DateMaskField,
  SelectField,
  RadioGroupField,
} from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import CostEstimateActions from 'agent_portal/actions/CostEstimateActions';
import SpinnerButton from 'shared/components/SpinnerButton';

const providerPriceFromForm = vals => {
  if (vals.projectedCharges && vals.medicarePercentage) {
    return +vals.projectedCharges * (+vals.medicarePercentage / 100);
  } else if (vals.allInPrice) {
    return vals.allInPrice;
  } else {
    /* eslint-disable no-alert */
    window.alert('Must include pricing information!');
    return null;
    /* eslint-enable no-alert */
  }
};

const submit = vals => {
  const params = {
    provider_price: providerPriceFromForm(vals),
    network: vals.networkStatus,
    payer_id: vals.payerId,
    member_id: vals.insuranceMemberID,
    member_dob: moment(vals.patientDOB, 'MM/DD/YYYY').format('YYYY-MM-DD'),
  };
  return CostEstimateActions.createCostEstimate(params);
};

const CostEstimateForm = ({ handleSubmit, payers, submitting }) => (
  <HForm onSubmit={handleSubmit(submit)}>
    <TextField name="insuranceMemberID" label="Insurance Member ID" />
    <DateMaskField mask="dob" name="patientDOB" label="Patient DOB" placeholder="mm/dd/yyyy" />
    <RadioGroupField
      name="networkStatus"
      label="Network"
      options={[
        { value: 'IN', label: 'In Network' },
        { value: 'OUT', label: 'Out of Network' },
      ]}
    />
    <SelectField
      name="payerId"
      label="Patient's Insurance Provider"
      options={payers.map(p => ({ value: p.id, label: p.name }))}
    />
    <TextField name="projectedCharges" label="Projected Charges (Medicare Rates)" />
    <TextField name="medicarePercentage" label="Medicare Percentage" />
    OR
    <TextField name="allInPrice" label="All In Price" />
    <div className="form-actions">
      <SpinnerButton className="btn btn-primary" type="submit" loading={submitting}>
        Submit
      </SpinnerButton>
    </div>
  </HForm>
);

export default reduxForm({
  form: 'costEstimate',
  initialValues: {
    networkStatus: 'IN',
  },
})(CostEstimateForm);
